import { Badge, useTheme } from '@mui/material';

const PrimaryAppBarBadge = ({ children, label, testId }) => {
  const theme = useTheme();
  return (
    <Badge
      data-testid={testId}
      data-cy={testId}
      color="error"
      sx={{
        '& .MuiBadge-badge': {
          fontWeight: theme.typography.subtitle1.fontWeight,
          marginTop: theme.spacing(0.8),
        },
      }}
      badgeContent={label || 0}
    >
      {children}
    </Badge>
  );
};

export default PrimaryAppBarBadge;
